import { useEffect, useMemo, useState } from "react";
import { NewDynamicTab } from "../../../components/Page";
import { ConsumptionDefaultDates } from "../../../config/DefaultDates";
import { getCAGDateOfDataAvailable } from "../../../Rest_api/RestApi";
import { Demand } from "./Tabs/Demand";
import { Generation } from "./Tabs/Generation";
import { Outage } from "./Tabs/Outage2";
import { Overview } from "./Tabs/Overview";
import { TrendAnalysis } from "./Tabs/trend";

const Consumption = () => {
  const [commonDate, setCommonDate] = useState<string | null>(null);
  const [dateLoaded, setDateLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getCAGDateOfDataAvailable()
      .then((res) => {
        if (!cancelled) {
          if (res?.common_date) setCommonDate(res.common_date);
          setDateLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) setDateLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const defaultDates = useMemo(() => {
    if (!commonDate) return ConsumptionDefaultDates;
    const endDate = new Date(commonDate);
    const startDate = new Date(commonDate);
    startDate.setDate(endDate.getDate() - 4);

    const pad2 = (n: number) => String(n).padStart(2, "0");
    const fmt = (d: Date) =>
      `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    const endStr = fmt(endDate);

    const trendOptions =
      (ConsumptionDefaultDates as any)["Trend Analysis"]?.trendDateOptions ?? [];
    const monthLabel = trendOptions[0]?.label ?? "";
    const monthStart = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    const defaultTrendEntry = {
      value: `${fmt(monthStart)},${endStr}`,
      label: monthLabel,
    };

    return {
      ...ConsumptionDefaultDates,
      Overview: {
        ...ConsumptionDefaultDates.Overview,
        type: "range",
        defaultRangeDate: {
          startDate,
          endDate,
          key: "selection",
        },
      },
      "Trend Analysis": {
        ...(ConsumptionDefaultDates as any)["Trend Analysis"],
        type: "trend",
        trendDateOptions: trendOptions,
        defaultTrendDates: [defaultTrendEntry],
      },
    };
  }, [commonDate]);

  if (!dateLoaded) return null;

  return (
    <NewDynamicTab
      headerHeight="h-[68px]"
      showTabs={true}
      defaultDates={defaultDates}
      trendTabs={["Trend Analysis"]}
      header="Consumption & Generation Analytics"
      tabs={{
        Overview: <Overview />,
        "Trend Analysis": <TrendAnalysis />,
        // Generation: <Generation />,
        // Outage: <Outage />,
      }}
    />
  );
};

export default Consumption;
